import { render, staticRenderFns } from "./TagReference.vue?vue&type=template&id=28303ef8&scoped=true"
import script from "./TagReference.vue?vue&type=script&lang=js"
export * from "./TagReference.vue?vue&type=script&lang=js"
import style0 from "./TagReference.vue?vue&type=style&index=0&id=28303ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28303ef8",
  null
  
)

export default component.exports